import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import { cn } from '../../../lib/utils';

export function WorkOrderMetaRow({
  label,
  value,
  wide,
}: {
  label: string;
  value: string;
  wide?: boolean;
}) {
  const { colors } = useTheme();
  return (
    <div
      className={cn(
        'grid gap-x-3 gap-y-0.5 border-b py-2.5 last:border-b-0',
        colors.border,
        wide ? 'grid-cols-1' : 'grid-cols-[7.5rem_minmax(0,1fr)]',
      )}
    >
      <dt className={cn('text-xs leading-5', colors.textMuted)}>{label}</dt>
      <dd className={cn('text-sm leading-5 break-words', colors.text)}>{value || ''}</dd>
    </div>
  );
}

export function WorkOrderPaneLabel({ children }: { children: React.ReactNode }) {
  const { colors } = useTheme();
  return (
    <p className={cn('text-[11px] font-semibold uppercase tracking-[0.08em]', colors.textMuted)}>
      {children}
    </p>
  );
}
